import styles from "./MainLayout.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";

interface MainLayoutProps {
    header?: React.ReactNode;
    footer?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

export const MainLayout = ({
    header,
    footer,
    children,
    className,
}: MainLayoutProps) => {
    return (
        <div
            className={classNames(
                styles.main,
                {
                    [styles.hasHeader]: !!header,
                },
                [className],
            )}
        >
            {header && header}
            {children}
            {footer && footer}
        </div>
    );
};
